import React, { useState } from 'react';
import { Accordion } from 'react-accessible-accordion';
import { SessionInfo } from '../Blocks/View/SessionInfo/SessionInfo';
import GeneralInfo from '../Blocks/View/GeneralInfo/GeneralInfo';
import { FinalIndicatorsView } from '../Blocks/View/FinalIndicators/FinalIndicators';
import PhotosBlockView from '../Blocks/View/PhotosBlockView/PhotosBlockView';
import AttachmentsBlockView from '../Blocks/View/AttachmentsBlockView/AttachmentsBlockView';
import { TranslateWrapperComponent } from 'component/Translation';
import { ReactComponent as TranslateSvg } from 'assets/images/icons/translate_24px.svg';

const CheckEORETab = ({
  formData,
  zone,
  setZone,
  handouts,
  photos,
  attachments,
  setLoader,
  filteredFinalIndicatorsComments,
  filteredGeneralComments,
  filteredSessionInformationComments,
}) => {
  const [translateState, setTranslateState] = useState(false);
  const [translatedFormData, setTranslatedFormData] = useState({});

  if (!formData || !formData.info) {
    return <div>Завантаження...</div>;
  }

  return (
    <>
      <TranslateWrapperComponent
        formData={{ ...formData, report_type: 'eore_report' }}
        setTranslatedFormData={setTranslatedFormData}
        translationState={translateState}
      >
        <div className="text-hover flex-group flex-right" onClick={() => setTranslateState(!translateState)}>
          <TranslateSvg />
          <span>Translate</span>
        </div>

        <div className="info_block_header">
          <div className="info_block_header_left">Атрибути</div>
          <span className="info_block_header_line" />
          <div className="info_block_header_right">Attributes</div>
        </div>

        <Accordion
          allowMultipleExpanded
          allowZeroExpanded
          preExpanded={[
            'general',
            'sessionInformation',
            'finalIndicators',
          ]}
          className="custom-accordion"
        >
          <GeneralInfo
            formData={formData}
            mode="check"
            comments={filteredGeneralComments || []}
            translatedFormData={translatedFormData}
            translateState={translateState}
          />
          <SessionInfo
            formData={formData}
            comments={filteredSessionInformationComments || []}
            handouts={handouts || []}
            zone={zone}
            setZone={setZone}
            mode="check"
            translatedFormData={translatedFormData}
            translateState={translateState}
          />
          <FinalIndicatorsView
            formData={formData}
            comments={filteredFinalIndicatorsComments || []}
            mode="check"
          />
          <PhotosBlockView
            formData={formData}
            photos={photos || []}
            setLoader={setLoader}
          />
          <AttachmentsBlockView
            attachments={attachments || []}
            setLoader={setLoader}
            formData={formData}
          />
        </Accordion>
      </TranslateWrapperComponent>
    </>
  );
};

export default CheckEORETab;
